import React from 'react';

export default function Block2_5Concentration() {
  const nodes = Array.from({ length: 100 }, (_, i) => {
    const isHighlighted = i < 20;
    return (
      <div 
        key={i} 
        className={`w-3 h-3 rounded-full ${isHighlighted ? 'bg-brand' : 'bg-line'}`}
        aria-hidden="true"
      />
    );
  });

  return (
    <section className="py-10 md:py-20 px-4 md:px-16 bg-surface border-b border-line">
      <div className="max-w-[1280px] mx-auto flex flex-col items-center">
        <div className="text-center mb-16 md:mb-24 max-w-4xl">
          <div className="text-[14px] font-semibold text-brand tracking-widest uppercase mb-4">
            Gestión Poblacional
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[48px] font-bold text-ink leading-[1.2] tracking-tight mb-6">
            La demanda no se distribuye de manera uniforme.
          </h2>
          <p className="text-[16px] md:text-[20px] text-ink-soft leading-[1.6] max-w-3xl mx-auto">
            En un análisis exploratorio de uno de nuestros pilotos en APS, el <span className="font-bold text-ink">20% de los usuarios concentró aproximadamente el 70% de las prestaciones observadas.</span> Esto no significa que esas prestaciones sean innecesarias; muchas veces se trata de personas con mayores necesidades de cuidado.</p>
          <p className="text-[16px] md:text-[20px] text-ink-soft leading-[1.6] max-w-3xl mx-auto mt-4">
            El desafío es operativo: cuando la necesidad se concentra y la capacidad es limitada, la red necesita saber a quién priorizar, qué falta y qué debe ocurrir después.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-24 w-full max-w-6xl">
          <div className="flex flex-col items-center gap-8 w-full lg:w-1/2">
            <div className="hidden sm:flex flex-wrap gap-7 justify-center max-w-[400px]">
              {nodes}
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-8 bg-paper p-6 rounded-2xl border border-line w-full sm:w-auto justify-center">
              <div className="text-center">
                <div className="text-[40px] md:text-[56px] font-bold text-brand leading-none">20%</div>
                <div className="text-[12px] font-bold text-ink-soft tracking-widest uppercase mt-2">Usuarios</div>
              </div>
              <div className="text-[50px] font-light text-line text-[rgb(102,51,255)]">≈</div>
              <div className="text-center">
                <div className="text-[40px] md:text-[56px] font-bold text-ink leading-none">70%</div>
                <div className="text-[12px] font-bold text-ink-soft tracking-widest uppercase mt-2">Prestaciones observadas</div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-[40%] flex flex-col items-start bg-paper p-8 md:p-10 rounded-2xl border border-line">
            <h3 className="text-[20px] font-bold text-ink mb-8 leading-[1.3]">
              Si la necesidad se concentra, la capacidad también debe poder priorizarse.
            </h3>
            <div className="flex flex-col gap-3 w-full font-mono text-[13px] md:text-[14px] uppercase tracking-widest">
              <div className="flex items-center gap-4 text-ink-soft">
                <div className="w-1.5 h-1.5 rounded-full bg-line" />
                <span>Población</span>
              </div>
              <div className="w-[1px] h-4 bg-line ml-[2px]" />
              <div className="flex items-center gap-4 text-ink-soft">
                <div className="w-1.5 h-1.5 rounded-full bg-brand" />
                <span className="font-bold text-ink">Demanda Concentrada</span>
              </div>
              <div className="w-[1px] h-4 bg-brand/30 ml-[2px]" />
              <div className="flex items-center gap-4 text-ink-soft">
                <div className="w-1.5 h-1.5 rounded-full bg-brand/50" />
                <span>Capacidad Limitada</span>
              </div>
              <div className="w-[1px] h-4 bg-brand/30 ml-[2px]" />
              <div className="flex items-center gap-4 text-ink-soft">
                <div className="w-1.5 h-1.5 rounded-full bg-brand/70" />
                <span>Prioridad</span>
              </div>
              <div className="w-[1px] h-4 bg-brand/30 ml-[2px]" />
              <div className="flex items-center gap-4 text-brand font-bold bg-brand/10 px-3 py-2 rounded-lg -ml-3 w-max">
                <div className="w-1.5 h-1.5 rounded-full bg-brand" />
                <span>Próxima Acción</span>
              </div>
            </div>
            <div className="mt-10 pt-6 border-t border-line w-full">
              <div className="text-[18px] md:text-[20px] font-bold text-ink">
                ¿Quién necesita qué acción, ahora?
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 w-full max-w-4xl mx-auto border-t border-line pt-6">
          <p className="text-[12px] text-ink-soft/70 leading-[1.6]">
            <strong>Nota metodológica:</strong> Análisis exploratorio de un piloto APS. La concentración de utilización no equivale por sí sola a riesgo clínico ni implica uso inapropiado de prestaciones.
          </p>
        </div>
      </div>
    </section>
  );
}
